"use client";

import { c as _c } from "react/compiler-runtime";
import { IconChevronLeft, IconMenu2 } from "@tabler/icons-react";
import { useRef, useState } from "react";
import { CartButton } from "@/components/custom/Cart/CartButton";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Sheet, SheetContent, SheetDescription, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { trackNavItemClicked } from "@/lib/analytics/segment";
import { getNavItemChildren, type NavItemEntry, navItemDestination } from "@/lib/contentful/navItem";
import { colorClass } from "@/lib/contentful/ui";
import { cn } from "@/lib/utils";
import { AccountMenu } from "./AccountMenu";
import { CmsLink } from "./CmsLink";
import { Logo } from "./Logo";
import { SearchTrigger } from "./Search/SearchTrigger";
interface Props {
  navItems: NavItemEntry[];
  isLoggedIn: boolean;
}
export function MainNavMobile(t0) {
  const $ = _c(53);
  const {
    navItems,
    isLoggedIn
  } = t0;
  const [open, setOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const triggerRefs = useRef(new Map());
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function closeAll() {
      setOpen(false);
      setActiveItem(null);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const closeAll = t1;
  const closeSubmenu = function closeSubmenu() {
    const id = activeItem?.sys.id;
    setActiveItem(null);
    if (id) {
      triggerRefs.current.get(id)?.focus();
    }
  };
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function handleLinkClick(label, level, href) {
      trackNavItemClicked({
        label,
        destinationUrl: href,
        level
      });
      closeAll();
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleLinkClick = t2;
  const t3 = "flex w-full justify-between px-3 py-2 xl:hidden";
  const t4 = "flex items-center gap-1";
  const T0 = Sheet;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = v => {
      setOpen(v);
      if (!v) {
        setActiveItem(null);
      }
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SheetTrigger asChild={true}><Button variant="ghost" size="icon" aria-label="Open menu"><IconMenu2 className="size-5" /></Button></SheetTrigger>;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const T1 = SheetContent;
  const t7 = "left";
  const t8 = "w-full max-w-97.5 overflow-hidden border-r border-border bg-background p-0 shadow-lg";
  const t9 = true;
  const t10 = activeItem?.fields.title ?? "Navigation";
  let t11;
  if ($[4] !== t10) {
    t11 = <SheetTitle className="sr-only">{t10}</SheetTitle>;
    $[4] = t10;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  let t12;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SheetDescription className="sr-only">Browse products, account links, and search.</SheetDescription>;
    $[6] = t12;
  } else {
    t12 = $[6];
  }
  const t13 = "relative h-full w-full";
  const t14 = activeItem ? "-translate-x-full pointer-events-none" : "translate-x-0";
  let t15;
  if ($[7] !== t14) {
    t15 = cn("absolute inset-0 flex flex-col items-stretch overflow-x-hidden overflow-y-auto pt-11 px-6 pb-6 transition-transform duration-300 contain-paint will-change-transform", t14);
    $[7] = t14;
    $[8] = t15;
  } else {
    t15 = $[8];
  }
  const t16 = navItems.map(item => {
    const {
      title,
      color,
      isNewTab
    } = item.fields;
    const itemChildren = getNavItemChildren(item);
    return <div key={item.sys.id}>{itemChildren.length > 0 ? <Button ref={el => {
        if (el) {
          triggerRefs.current.set(item.sys.id, el);
        } else {
          triggerRefs.current.delete(item.sys.id);
        }
      }} variant="ghost" onClick={() => setActiveItem(item)} aria-expanded={activeItem?.sys.id === item.sys.id} aria-controls="mobile-nav-submenu" className="group h-18 w-full justify-between gap-4 px-0 has-[>svg]:px-0 font-normal hover:bg-transparent"><span className={cn("text-sm font-medium", colorClass(color))}>{title}</span><IconChevronLeft className={cn("size-4 rotate-180", colorClass(color))} /></Button> : <CmsLink destination={navItemDestination(item)} isNewTab={isNewTab} className={cn("flex h-18 w-full items-center text-sm font-medium no-underline!", colorClass(color))} onNavigate={href_0 => handleLinkClick(title, 1, href_0)}>{title}</CmsLink>}<Separator /></div>;
  });
  let t17;
  if ($[9] !== t15 || $[10] !== t16) {
    t17 = <nav className={t15}>{t16}</nav>;
    $[9] = t15;
    $[10] = t16;
    $[11] = t17;
  } else {
    t17 = $[11];
  }
  const t18 = activeItem ? "translate-x-0" : "translate-x-full pointer-events-none";
  let t19;
  if ($[12] !== t18) {
    t19 = cn("absolute inset-0 flex flex-col items-stretch overflow-hidden pt-11 px-6 pb-6 transition-transform duration-300 contain-paint will-change-transform", t18);
    $[12] = t18;
    $[13] = t19;
  } else {
    t19 = $[13];
  }
  let t20;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <IconChevronLeft className="size-4" />;
    $[14] = t20;
  } else {
    t20 = $[14];
  }
  const t21 = activeItem?.fields.title;
  let t22;
  if ($[15] !== t21) {
    t22 = <span className="text-lg font-semibold leading-7 text-foreground">{t21}</span>;
    $[15] = t21;
    $[16] = t22;
  } else {
    t22 = $[16];
  }
  let t23;
  if ($[17] !== closeSubmenu || $[18] !== t22) {
    t23 = <Button variant="ghost" onClick={closeSubmenu} aria-label="Back to main menu" className="-ml-2 h-auto shrink-0 justify-start gap-2 self-start px-0 has-[>svg]:px-0 font-normal hover:bg-transparent">{t20}{t22}</Button>;
    $[17] = closeSubmenu;
    $[18] = t22;
    $[19] = t23;
  } else {
    t23 = $[19];
  }
  let t24;
  if ($[20] !== activeItem || $[21] !== handleLinkClick) {
    t24 = activeItem && getNavItemChildren(activeItem).map(col => {
      const {
        title: colTitle,
        color: colColor,
        isNewTab: colIsNewTab
      } = col.fields;
      return <div key={col.sys.id}><CmsLink destination={navItemDestination(col)} isNewTab={colIsNewTab} className={cn("flex h-18 w-full items-center text-sm font-bold no-underline!", colorClass(colColor))} onNavigate={href_1 => handleLinkClick(colTitle, 2, href_1)}>{colTitle}</CmsLink><Separator />{getNavItemChildren(col).map(item_0 => {
          const {
            title: itemTitle,
            color: itemColor,
            isNewTab: itemIsNewTab
          } = item_0.fields;
          return <div key={item_0.sys.id}><CmsLink destination={navItemDestination(item_0)} isNewTab={itemIsNewTab} className={cn("flex h-18 w-full items-center pl-8 text-sm no-underline!", colorClass(itemColor))} onNavigate={href_2 => handleLinkClick(itemTitle, 3, href_2)}>{itemTitle}</CmsLink><Separator /></div>;
        })}</div>;
    });
    $[20] = activeItem;
    $[21] = handleLinkClick;
    $[22] = t24;
  } else {
    t24 = $[22];
  }
  let t25;
  if ($[23] !== t24) {
    t25 = <div className="mt-4 flex w-full flex-col overflow-y-auto">{t24}</div>;
    $[23] = t24;
    $[24] = t25;
  } else {
    t25 = $[24];
  }
  let t26;
  if ($[25] !== t19 || $[26] !== t23 || $[27] !== t25) {
    t26 = <div id="mobile-nav-submenu" className={t19}>{t23}{t25}</div>;
    $[25] = t19;
    $[26] = t23;
    $[27] = t25;
    $[28] = t26;
  } else {
    t26 = $[28];
  }
  let t27;
  if ($[29] !== t17 || $[30] !== t26) {
    t27 = <div className={t13}>{t17}{t26}</div>;
    $[29] = t17;
    $[30] = t26;
    $[31] = t27;
  } else {
    t27 = $[31];
  }
  let t28;
  if ($[32] !== T1 || $[33] !== t11 || $[34] !== t12 || $[35] !== t27) {
    t28 = <T1 side={t7} className={t8} showCloseButton={t9}>{t11}{t12}{t27}</T1>;
    $[32] = T1;
    $[33] = t11;
    $[34] = t12;
    $[35] = t27;
    $[36] = t28;
  } else {
    t28 = $[36];
  }
  let t29;
  if ($[37] !== T0 || $[38] !== open || $[39] !== t28 || $[40] !== t5 || $[41] !== t6) {
    t29 = <T0 open={open} onOpenChange={t5}>{t6}{t28}</T0>;
    $[37] = T0;
    $[38] = open;
    $[39] = t28;
    $[40] = t5;
    $[41] = t6;
    $[42] = t29;
  } else {
    t29 = $[42];
  }
  let t30;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <SearchTrigger />;
    $[43] = t30;
  } else {
    t30 = $[43];
  }
  let t31;
  if ($[44] !== t29) {
    t31 = <div className={t4}>{t29}{t30}</div>;
    $[44] = t29;
    $[45] = t31;
  } else {
    t31 = $[45];
  }
  let t32;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Logo />;
    $[46] = t32;
  } else {
    t32 = $[46];
  }
  let t33;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <CartButton />;
    $[47] = t33;
  } else {
    t33 = $[47];
  }
  let t34;
  if ($[48] !== isLoggedIn) {
    t34 = <div className="flex items-center gap-1">{t33}<AccountMenu isLoggedIn={isLoggedIn} /></div>;
    $[48] = isLoggedIn;
    $[49] = t34;
  } else {
    t34 = $[49];
  }
  let t35;
  if ($[50] !== t31 || $[51] !== t34) {
    t35 = <div className={t3}>{t31}{t32}{t34}</div>;
    $[50] = t31;
    $[51] = t34;
    $[52] = t35;
  } else {
    t35 = $[52];
  }
  return t35;
}